export const COLUMN_CATEGORIES_TABLE = "column_categories";
export const COLUMN_CATEGORY_ROUTE_BASE = "/column-categories";

export const DEFAULT_BADGE_BG_COLOR = "#EEF2F7";
export const DEFAULT_BADGE_TEXT_COLOR = "#344054";
